import JPIcon1 from './JPIcon1';
import JPIcon2 from './JPIcon2';
import JPIcon3 from './JPIcon3';
import styled from './index.module.scss';

export default function JPTimeLine() {
    const content = [
        {
            date: '4/8 - 4/14',
            desc: '新規登録で限定ギフトをプレゼント',
            icon: <JPIcon1 />,
        },
        {
            date: '4/15 - 4/29',
            desc: '最大50%OFF エコポイント年間最大還元セール',
            icon: <JPIcon2 />,
        },
        {
            date: '4/30 - 5/3',
            desc: '人気商品の販売を再開予定！',
            icon: <JPIcon3 />,
        },
    ];

    return (
        <div className={styled.jptimeline}>
            <div className="line-bg"></div>
            <div className="date-word-content">
                {content.map((item, i) => (
                    <div className="word-item" key={i}>
                        <div className="date">
                            <span className="line-bg-icon">{item.icon}</span>
                            {item.date}
                        </div>
                        <div className="desc">{item.desc}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}
